import BaseService from 'services/BaseService';

//-------------------------------------------------------------------------------------------------------------------

export default class AccountService
    extends BaseService {

    static async getLoginInfo() {
        return BaseService.callAPI('account/get-login-info');
    }

    static async logIn(details) {
        return BaseService.callAPI('account/log-in', details);
    }

    static async logOut(details) {
        return BaseService.callAPI('account/log-out');
    }

    static async switchInstructor(id) {
        return BaseService.callAPI('account/switch-instructor/' + id);
    }

    static async sendPasswordResetEmail(email) {
        return BaseService.callAPI('account/send-password-reset-email', {
            email
        });
    }

    static async confirmPasswordReset(token, password) {
        return BaseService.callAPI('account/confirm-password-reset', {
            token, password
        });
    }
}